import KunLoading91 from './src/index'

KunLoading91.install = function (Vue) {
	Vue.component(KunLoading91.name, KunLoading91);
}

export default KunLoading91;
